export class NewCandidate {
  FullName?: string;
  CityId?: string;
  Phone?: string;
  CampaignId?: string;
  ReferrerId?: string;
  ReferrerDetailId?: string;
  SubReferrerDetailId?: string;

  constructor(
    fullName?: string,
    cityId?: string,
    phone?: string,
    campaignId?: string,
    referrerId?: string,
    referrerDetailId?: string,
    subReferrerDetailId?: string
  ) {
    this.FullName = fullName;
    this.CityId = cityId;
    this.Phone = phone;
    this.CampaignId = campaignId;
    this.ReferrerId = referrerId;
    this.ReferrerDetailId = referrerDetailId;
    this.SubReferrerDetailId = subReferrerDetailId;
  }
}
